import { useQuery } from "@tanstack/react-query";
import { prototypeApi } from "../service/prototype-service";

export const PROTOTYPES_QUERY_KEY = "prototypes";

export function usePrototypesQuery(adminPassword: string | null) {
    return useQuery({
        queryKey: [PROTOTYPES_QUERY_KEY],
        queryFn: () => prototypeApi.list(adminPassword!),
        enabled: !!adminPassword,
    });
}
